import script from "./Expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./Expenses.vue?vue&type=script&setup=true&lang=js"

import "./Expenses.vue?vue&type=style&index=0&id=20ce1dd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ce1dd7"]])

export default __exports__